export const PrintStatus = Object.freeze({
	Any: 'Any',
	Delivered: 'delivered',
	InTransit: 'in_transit',
	Other: 'no_delivery_scan',
	PendingRecipientAction: 'action_required',
	Printed: 'printed',
	Refunded: 'refunded',
	RefundPending: 'refund_pending',
	Undeliverable: 'undeliverable',
	Exception: 'exception',
	PartialRefundPending: 'partial_refund_pending',
});

export const PrintStatusForFilter = Object.freeze({
	Any: 'Any',
	Delivered: 'Delivered',
	InTransit: 'InTransit',
	Other: 'NoDeliveryScan',
	PendingRecipientAction: 'RecipientActionRequired',
	Printed: 'Printed',
	Refunded: 'Refunded',
	RefundPending: 'PendingRefund',
	Undeliverable: 'Undeliverable',
});

export default Object.freeze([
	{
		label: 'Any',
		value: PrintStatusForFilter.Any,
		dataqa: 'status-any',
	},
	{
		label: 'Printed',
		value: PrintStatusForFilter.Printed,
		dataqa: 'status-printed',
	},
	{
		label: 'In Transit',
		value: PrintStatusForFilter.InTransit,
		dataqa: 'status-in-transit',
	},
	{
		label: 'Delivered',
		value: PrintStatusForFilter.Delivered,
		dataqa: 'status-delivered',
	},
	{
		label: 'Pending Recipient Action',
		value: PrintStatusForFilter.PendingRecipientAction,
		dataqa: 'status-pending-recipient-action',
	},
	{
		label: 'Undeliverable',
		value: PrintStatusForFilter.Undeliverable,
		dataqa: 'status-undeliverable',
	},
	{
		label: 'Refund Pending',
		value: PrintStatusForFilter.RefundPending,
		dataqa: 'status-refund-pending',
	},
	{
		label: 'Refunded',
		value: PrintStatusForFilter.Refunded,
		dataqa: 'status-refunded',
	},
	{
		label: 'Other',
		value: PrintStatusForFilter.Other,
		dataqa: 'status-other',
	},
]);
